import type {
  Business,
  BusinessSummary,
  CreateBusinessInput,
  CreateTeammateInput,
  Stats,
  Teammate,
  TeammateSummary,
} from "./types";

const base = "";

export async function createTeammate(input: CreateTeammateInput): Promise<Teammate> {
  const r = await fetch(`${base}/api/teammates`, {
    method: "POST",
    headers: { "content-type": "application/json" },
    body: JSON.stringify(input),
  });
  if (!r.ok) {
    const e = (await r.json().catch(() => null)) as { error?: string } | null;
    throw new Error(e?.error || `HTTP ${r.status}`);
  }
  return r.json();
}

export async function getTeammate(id: string): Promise<Teammate> {
  const r = await fetch(`${base}/api/teammates/${id}`);
  if (!r.ok) throw new Error(`HTTP ${r.status}`);
  return r.json();
}

export async function listTeammates(params?: {
  session?: number;
  limit?: number;
}): Promise<TeammateSummary[]> {
  const qs = new URLSearchParams();
  if (params?.session) qs.set("session", String(params.session));
  if (params?.limit) qs.set("limit", String(params.limit));
  const r = await fetch(`${base}/api/teammates?${qs}`);
  if (!r.ok) throw new Error(`HTTP ${r.status}`);
  return r.json();
}

export async function getStats(sessionId?: number | "all"): Promise<Stats> {
  const qs = new URLSearchParams();
  if (sessionId && sessionId !== "all") qs.set("session", String(sessionId));
  const r = await fetch(`${base}/api/stats?${qs}`);
  if (!r.ok) throw new Error(`HTTP ${r.status}`);
  return r.json();
}

// Reimagine your business — Session 02
export async function createBusiness(input: CreateBusinessInput): Promise<Business> {
  const r = await fetch(`${base}/api/businesses`, {
    method: "POST",
    headers: { "content-type": "application/json" },
    body: JSON.stringify(input),
  });
  if (!r.ok) {
    const e = (await r.json().catch(() => null)) as { error?: string } | null;
    throw new Error(e?.error || `HTTP ${r.status}`);
  }
  return r.json();
}

export async function getBusiness(id: string): Promise<Business> {
  const r = await fetch(`${base}/api/businesses/${id}`);
  if (!r.ok) throw new Error(`HTTP ${r.status}`);
  return r.json();
}

export async function listBusinesses(params?: { limit?: number }): Promise<BusinessSummary[]> {
  const qs = new URLSearchParams();
  if (params?.limit) qs.set("limit", String(params.limit));
  const r = await fetch(`${base}/api/businesses?${qs}`);
  if (!r.ok) throw new Error(`HTTP ${r.status}`);
  return r.json();
}

export async function commitToMove(id: string, commitment: "automate" | "launch" | "expand"): Promise<Business> {
  const r = await fetch(`${base}/api/businesses/${id}`, {
    method: "PATCH",
    headers: { "content-type": "application/json" },
    body: JSON.stringify({ commitment }),
  });
  if (!r.ok) throw new Error(`HTTP ${r.status}`);
  return r.json();
}
